module.exports = __webpack_public_path__ + "static/img/alertaddress.98aa3a5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/activty/alertaddress.svg
// module id = FRBJ
// module chunks = 1